import Fraction from 'fraction.js';
import React from 'react';
import { isFunction } from 'lodash';

class FractionField extends React.Component {
	constructor(props) {
		super(props);
		const { option } = props;
		const optionValue = option?.value ? option?.value : '0';

		const [wholeValue, fractionValue] = this.getSeperatedNumbers(props.value);

		this.state = {
			fractionValue,
			wholeValue,
		};
		this.props = props;
		this.getSeperatedNumbers = this.getSeperatedNumbers.bind(this);

		this.valid_fractions = [
			0.0625, 0.125, 0.1875, 0.25, 0.3125, 0.375, 0.4375, 0.5, 0.5625, 0.625, 0.6875, 0.75,
			0.8125, 0.875, 0.9375,
		];
	}

	setNewValue(newValue) {
		const [wholeValue, fractionValue] = this.getSeperatedNumbers(newValue);
		this.setState({
			fractionValue,
			wholeValue,
		});
	}

	blurred(newValue) {
		this.props?.onChange && this.props?.onChange(newValue);
		if (this.props.onBlur) {
			this.props.onBlur(newValue);
		}
	}

	get totalValue() {
		return this.state.wholeValue + this.state.fractionValue;
	}

	getSeperatedNumbers(value) {
		const values = (value ?? '').toString().split('.');
		let wholeValue = '0';
		let fractionValue = '0';

		if (value !== null) {
			wholeValue = typeof Number(value) === 'number' ? parseInt(values[0], 10) : '';
			fractionValue = parseFloat(`0.${values.length > 1 ? values[1] : '0'}`);
		} else {
			wholeValue = '';
			fractionValue = '';
		}

		return [wholeValue, fractionValue];
	}

	textInputBlurred(new_val) {
		const { option } = this.props;

		new_val = parseFloat(new_val);

		const min = isFunction(option?.minValue)
			? option?.minValue(option?.shade)
			: (option?.minValue ?? this.props.minValue ?? Number.MIN_VALUE);

		const max = isFunction(option?.maxValue)
			? option?.maxValue(option?.shade)
			: (option?.maxValue ?? this.props.maxValue ?? Number.MAX_VALUE);

		const maxValue = option?.complexMaxValueOverride
			? option?.complexMaxValueOverride(option?.shade)
			: max;

		if (new_val < min) {
			new_val = min;
		} else if (new_val > maxValue) {
			new_val = maxValue;
		}

		const [wholeValue, fractionValue] = this.getSeperatedNumbers(new_val);

		this.blurred(wholeValue + fractionValue);

		this.setState({
			fractionValue,
			wholeValue,
		});
	}

	numberChanged(new_val) {
		const { option } = this.props;
		const maxValue = option?.complexMaxValueOverride
			? option?.complexMaxValueOverride(option?.shade)
			: (option?.maxValue ?? this.props.maxValue);

		if (new_val > maxValue) {
			new_val = maxValue;
		}

		if ((`${new_val}`).includes('-')) {
			new_val = Math.abs(new_val);
		}

		this.setState({ fractionValue: new_val });
	}

	nonFractionChange(new_val) {
		this.setState({
			wholeValue: new_val,
		});
	}

	fractionChange(new_val) {
		this.textInputBlurred(this.state.wholeValue + new_val);
	}

	onChangedForWhole(new_val) {
		const [wholeNumber, fractionNumber] = this.getSeperatedNumbers(new_val);

		if (Number(new_val)) {
			if (fractionNumber > 0) {
				const convertToFraction = (decimal) => {
					const rounded = this.roundToNearestFraction(decimal);
					return parseFloat(rounded);
				};

				this.textInputBlurred(parseFloat(wholeNumber) + convertToFraction(fractionNumber));
			} else {
				const fractionVal = !this.state.fractionValue ? 0 : parseFloat(this.state.fractionValue);

				this.textInputBlurred(parseFloat(new_val) + fractionVal);
			}
		}
	}

	roundToNearestFraction(decimal) {
		const fractions = [0.0625, 0.125, 0.1875, 0.25, 0.3125, 0.375, 0.4375, 0.5, 0.5625, 0.625, 0.6875, 0.75, 0.8125, 0.875, 0.9375, 1];
		let lowerFraction = 0;
		let higherFraction = 1;

		for (let i = 0; i < fractions.length; i++) {
			if (decimal < fractions[i]) {
				higherFraction = fractions[i];
				lowerFraction = i > 0 ? fractions[i - 1] : 0;
				break;
			}
		}
		
		const roundedDown = lowerFraction;
		const roundUpThreshold = higherFraction - 0.0006;
		return decimal > roundUpThreshold ? higherFraction : roundedDown;
	}

	render() {
		const { props } = this;

		const displayValue = Math.floor(this.state.value);

		const { option, keepOldStyle, small } = this.props;

		const { value } = this.state;

		const fractionOptions = [
			{ value: 0, displayValue: '0' },
			{ value: 0.0625, displayValue: '1/16' },
			{ value: 0.125, displayValue: '1/8' },
			{ value: 0.1875, displayValue: '3/16' },
			{ value: 0.25, displayValue: '1/4' },
			{ value: 0.3125, displayValue: '5/16' },
			{ value: 0.375, displayValue: '3/8' },
			{ value: 0.4375, displayValue: '7/16' },
			{ value: 0.5, displayValue: '1/2' },
			{ value: 0.5625, displayValue: '9/16' },
			{ value: 0.625, displayValue: '5/8' },
			{ value: 0.6875, displayValue: '11/16' },
			{ value: 0.75, displayValue: '3/4' },
			{ value: 0.8125, displayValue: '13/16' },
			{ value: 0.875, displayValue: '7/8' },
			{ value: 0.9375, displayValue: '15/16' },
		];

		const convertToFraction = (decimal) => {
			const rounded = this.roundToNearestFraction(decimal);
			const f = new Fraction(rounded);
			return f.toFraction(true);
		};

		const { fractionValue } = this.state;

		const display = convertToFraction(fractionValue);

		const options = fractionOptions.map((fo, index) => (
			<option key={index} value={fo.value}>
				{fo.displayValue}
			</option>
		));

		return (
			<div className="fraction-outer">
				<div className="fraction-inner-whole">
					<input
						className={keepOldStyle ? '' : 'form-control-sm'}
						onKeyDown={(e) => props.handleEnter && props.handleEnter(e)}
						disabled={props.disabled}
						name={option?.field_name ?? props.field_name}
						type="number"
						value={this.state.wholeValue}
						onBlur={(e) => this.onChangedForWhole(e.target.value)}
						onChange={(e) => {
							this.nonFractionChange(parseFloat(e.target.value));
						}}
						placeholder={props.placeholderLabel ? option?.label : '-'}
					/>
				</div>
				<div className="fraction-inner-select">
					{this.props.isCoupled ? <br /> : null}
					<select
						className={keepOldStyle ? '' : (small ? "form-select form-select-sm" : "form-select")}
						disabled={props.disabled}
						style={{
							height: '2em'
						}}
						value={fractionValue}
						onChange={(e) => {
							this.fractionChange(parseFloat(e.target.value));
						}}
					>
						{options}
					</select>
				</div>
			</div>
		);
	}
}

export default FractionField;
